import { WindowWidthContext } from '@minecraft.utils';
import { PaywallLocation } from './enums/PaywallLocation';

export const useRegistrationLocation = ({ paywallLocation }: { paywallLocation: PaywallLocation }) => {
  const isMobile = WindowWidthContext.useIsMobile();
  const isRegistration = paywallLocation === PaywallLocation.SIGNUP;

  const isMobileRegistration = isRegistration && isMobile;
  const isDesktopRegistration = isRegistration && !isMobile;

  return { isMobileRegistration, isDesktopRegistration, isRegistration };
};
